<template>
  <div
    class="the-car"
    data-help-title="Dein Auto"
    data-help="Dein eigenes Auto. Schalte verschiedene Belohnungen frei und klicke auf den Schraubenschlüssel um dein Auto nach deinen wünschen zu gestalten."
  >
    <template v-if="myCar && myCar.car">
      <div class="configure-btn" @click="setConfigureCar('car')">🔧</div>
      <Starter v-if="myCar.car == 'starter'" />
      <Coupe v-if="myCar.car == 'coupe'" />
      <Truck v-if="myCar.car == 'truck'" />
      <City v-if="myCar.car == 'city'" />
      <Cabrio v-if="myCar.car == 'cabrio'" />
      <Racer v-if="myCar.car == 'racer'" />
    </template>
    <BaseButton v-else @click="setConfigureCar('car')"
      >Wähle dein Auto</BaseButton
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import BaseButton from "@/components/BaseButton.vue";

import Starter from "@/components/CarStarter";
import Coupe from "@/components/CarCoupe";
import Truck from "@/components/CarTruck";
import City from "@/components/CarCity";
import Cabrio from "@/components/CarCabrio";
import Racer from "@/components/CarRacer";

export default {
  name: "TheCar",
  components: {
    Starter,
    Coupe,
    Truck,
    City,
    Cabrio,
    Racer,
    BaseButton,
  },
  computed: {
    ...mapGetters(["myCar"]),
  },
  methods: {
    ...mapActions(["setConfigureCar"]),
  },
};
</script>

<style lang="scss" scoped>
.the-car {
  height: 200px;
  background: $blue;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 5px solid #ffffff;
  position: relative;

  .configure-btn {
    position: absolute;
    right: 20px;
    top: 10px;
    width: 30px;
    height: 30px;
    font-size: 30px;
    cursor: pointer;
  }

  p,
  .message {
    color: #ffffff;
  }
}
</style>
